import "@angular/platform-browser";
import "@angular/platform-browser-dynamic";
import "@angular/animations";
import "@angular/core";
import "@angular/common";
import "@angular/http";
import "@angular/router";
import "@angular/forms";

import "rxjs";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/map";

import "jquery";
import * as Hammer from "hammerjs";
import "popper.js";
import "bootstrap";
import "ng2-file-upload";
import "rasterizehtml/dist/rasterizeHTML.allinone.js"; // eslint-disable-line import/extensions
import "lodash";
import "ngx-markdown";
import "uuid";

import "apollo-angular";
import "apollo-angular-link-http";
import "apollo-cache-inmemory";
import "apollo-link";
import "apollo-link-ws";
import "apollo-utilities";
import "graphql-tag";

Hammer.defaults.cssProps.userSelect = "auto";
Hammer.defaults.cssProps.userSelect = "auto";
Hammer.defaults.cssProps.userDrag = "auto";
